// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import "services/bao-template-engine";
import AppTabController from "../../services/app-tab-controller";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
function ConfigurationItemChildsViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(this, tabPage, parent);
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.SelectedChildItems = ko.observable();
    self.Sorting = ko.observableArray([]);
    self.ToolbarButtons = ko.observableArray([]);
    self.Sorting.subscribe(function () {
        self.refreshGrid();
    });
    parent.IsNew.subscribe(function () {
        setButtons();
    });
    var setButtons = function () {
        $.each(self.ToolbarButtons(), function (index, button) {
            if (button.ActionKey() == "ConfigurationItemRefreshChildNodes") {
                button.Enabled(true);
            }
            else {
                if (self.SelectedGridRow() != null) {
                    if (button.ActionKey() == "ConfigurationItemRemoveChildNode") {
                        if (ko.utils.unwrapObservable(self.SelectedGridRow().Data.ConfigurationItemId) == self.ConfigurationItem.ConfigurationItemId()) {
                            button.Enabled(false);
                        }
                        else {
                            button.Enabled(true);
                        }
                    }
                    else {
                        button.Enabled(!parent.IsNew());
                    }
                }
                else {
                    button.Enabled(false);
                }
            }
        });
    };
    self.ToolbarButtons.subscribe(setButtons);
    self.SelectGridRow = function (item) {
        self.SelectedGridRow(item);
        return true;
    };
    self.SelectedGridRow = ko.observable();
    self.SelectedGridRow.subscribe(setButtons);
    Bao.Templates.configurationItemChilds = "<tr data-bind=\"visible: Level == 0 || ($parent.Opened && RootOpened), click: Root.SelectGridRow, css: {'selected-blue': Root.SelectedGridRow() == $data}\">        <td data-bind='redrawIcons: Root.SelectedGridRow() == $data' style='white-space: nowrap'><i class=\"fa\" data-bind=\"style: {marginLeft: Level * 20 + 'px'}, click: Root.GetChildren,             css: Icon\"></i>             <span><a data-bind='attr: {href: Data.OpenUrl}, visible: Level > 0, text: Text'>{{Text}}</a><span data-bind='visible: Level == 0'>{{Text}}</span></span></td>        <td>{{Data.Number}}</td>        <td>{{Data.ConfigurationItemTypeName}}</td>        <td>{{Data.ConfigurationItemStatusName}}</td>        <td>{{Data.AccountAssignmentTypeName}}</td>        <td>{{Data.AccountAssignment}}</td>        <td>{{Data.CustomerName}}</td>        <td>{{Data.OwnerName}}</td>        <td>{{Data.DepartmentName}}</td>        <td>{{Data.BuildingName}}</td>        <td>{{Data.Room}}</td>        <td>{{Data.SerialNumber}}</td>        </tr>        <!-- ko template: {name: 'configurationItemChilds', foreach: GridNodes}  -->        <!-- /ko -->";
    self.OpenChild = function (item) {
        if (item != null && ko.utils.unwrapObservable(item.Data.ConfigurationItemId) != self.ConfigurationItem.ConfigurationItemId()) {
            var newTab = new TabPage();
            newTab.Url(item.Data.OpenUrl);
            newTab.UrlData({
                id: item.Data.OpenData
            });
            newTab.ObjectId(item.Data.OpenData);
            AppTabController.AddTab(newTab);
        }
    };
    self.TotalRows = ko.observable(-1);
    self.IsLoading = ko.observable(false);
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemNewChildNode":
                if (self.SelectedGridRow() != undefined && self.SelectedGridRow().Id != null) {
                    var newTab = new TabPage();
                    newTab.Url("ConfigurationItem/Index");
                    newTab.UrlData({
                        id: null,
                        parent: self.SelectedGridRow().Id
                    });
                    AppTabController.AddTab(newTab);
                }
                break;
            case "ConfigurationItemAddChildNode":
                if (self.SelectedGridRow() != undefined && self.SelectedGridRow().Id != null) {
                    self.AddChildItem();
                }
                break;
            case "ConfigurationItemRemoveChildNode":
                if (self.SelectedGridRow() != undefined && self.SelectedGridRow().Id != null) {
                    self.deleteItem();
                }
                break;
            case "ConfigurationItemRefreshChildNodes":
                self.refreshGrid();
                break;
        }
    };
    self.AddChildItem = function () { };
    self.SelectedChildItems.subscribe(function () {
        if (self.SelectedChildItems() != null) {
            self.AddChildToParent();
        }
    });
    self.AddChildToParent = function () {
        return Bao.post("ConfigurationItemTab/AddChildToParent", JSON.stringify({
            parentItemId: self.SelectedGridRow().Id,
            childConfigurationItemIds: self.SelectedChildItems()
        }), function (value) {
            if (value == "") {
                self.refreshGrid();
            }
            else {
                var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, value, "info");
            }
            self.SelectedChildItems(null);
        });
    };
    self.Refresh = function () {
        return self.refreshGrid();
    };
    self.refreshGrid = function () {
        self.SelectedGridRow(null);
        self.GridNodes([new NodeViewModel(self.ConfigurationItem.Name1, 0, self.ConfigurationItem, self.ConfigurationItem.ConfigurationItemId(), self.ConfigurationItem.OpenUrl(), self)]);
        return self.GetChildren(self.GridNodes()[0]);
    };
    self.deleteItem = function () {
        return Bao.post("ConfigurationItemTab/DeleteChildItem", JSON.stringify({
            itemId: self.SelectedGridRow().Id
        }), function (value) {
            if (value == true) {
                self.refreshGrid();
            }
        });
    };
    self.GetChildren = function (item) {
        var def = $.Deferred();
        if (item.Loaded() == false) {
            item.Loaded(true);
            tabPage.IsLoading(true);
            Bao.post("ConfigurationItemTab/GetConfigurationItemChildsCollection", JSON.stringify({
                parentConfigurationItemId: item.Id,
                sorting: self.Sorting()
            }), function (result) {
                var array = [];
                if (result != null && result.length > 0) {
                    $.each(result, function (index, row) {
                        var node = new NodeViewModel(row.Name1HtmlSafe, item.Level + 1, row, row.OpenData, row.OpenUrl, self);
                        if (row.HasChildren == false) {
                            node.GridNodes([]);
                            node.Loaded(true);
                        }
                        array[index] = node;
                    });
                }
                item.GridNodes(array);
                item.Opened(!item.Opened());
                tabPage.IsLoading(false);
                def.resolve();
            });
        }
        else {
            item.Opened(!item.Opened());
            def.resolve();
        }
        return def.promise();
    };
    self.GridNodes = ko.observableArray([new NodeViewModel(self.ConfigurationItem.Name1, 0, self.ConfigurationItem, self.ConfigurationItem.ConfigurationItemId(), self.ConfigurationItem.OpenUrl(), self)]);
    self.GetChildren(self.GridNodes()[0]);
    self.Save = function () {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    };
    self.init = function () { };
    self.loaded = function () {
        self.Refresh();
    };
}
;
Bao.inherit(ConfigurationItemChildsViewModel, ChildTabViewModel);
ConfigurationItemChildsViewModel.prototype.CompleteCheck = function () {
    return true;
};
export default ConfigurationItemChildsViewModel;